import { APP_NAME, PARENT_COMPANY_NAME } from '../../../config/appConstants';
import parentCompanyLogo from '../../../assets/images/THPL-app-logo.png';
import appLogo from '../../../assets/images/DevicePulse-app-logo2-trans.png';
import LegalPageNav from './LegalPageNav';

export default function AuthPageFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <div className="auth-page-footer">
      <div className="footer-brand-row">
        <img src={appLogo} className="emoji-app-logo" alt="" />
        <span className="footer-copyright">© {currentYear} {APP_NAME}</span>
        <LegalPageNav className="legal-page-nav--footer" />
      </div>
      <div className="powered-by-footer-attribution">
        <img src={parentCompanyLogo} className="emoji-parent-company-logo" alt="" />
        <span className="powered-by-text">Powered by {PARENT_COMPANY_NAME}</span>
      </div>
    </div>
  );
}
